import Vue from 'vue';
import VueI18nManager from 'vue-i18n-manager';
import store from '@/store';
import router from '@/router';
import { translation } from '@/helpers/translation'


const proxy = {
  getTranslation: async () => {
    const response = await store.dispatch('setting/GET_TRANSLATIONS');
    Vue.use(response, translation);
    return response;
  }
};


Vue.use(VueI18nManager, {
  store,
  router,
  proxy,
  config: {
    defaultCode: 'lt-LT',
    languages: [
      {
        name: 'Lietuvių',
        title: 'Lit.',
        key: 'lt',
        code: 'lt-LT',
        urlPrefix: 'lt',
        translationKey: 'lt'
      },
      {
        name: 'English',
        title: 'Eng.',
        key: 'en',
        code: 'en-US',
        urlPrefix: 'en',
        translationKey: 'en',
      },
    ],
    translations: proxy,
  },
});
